import {
  usePopoverStoreOptions,
  usePopoverStoreProps
} from "./3PKTK2K7.js";
import {
  useStore,
  useStoreProps
} from "./P63NRZ4A.js";
import {
  __spreadValues
} from "./PNRLI7OV.js";

// src/hovercard/hovercard-store.ts
import * as Core from "@ariakit/core/hovercard/hovercard-store";
function useHovercardStoreOptions(props) {
  return usePopoverStoreOptions(props);
}
function useHovercardStoreProps(store, props) {
  store = usePopoverStoreProps(store, props);
  useStoreProps(store, props, "timeout");
  useStoreProps(store, props, "showTimeout");
  useStoreProps(store, props, "hideTimeout");
  return store;
}
function useHovercardStore(props = {}) {
  const options = useHovercardStoreOptions(props);
  const store = useStore(
    () => Core.createHovercardStore(__spreadValues(__spreadValues({}, props), options))
  );
  return useHovercardStoreProps(store, props);
}

export {
  useHovercardStoreOptions,
  useHovercardStoreProps,
  useHovercardStore
};
